import React from "react";

const isSafari = () => {
  return navigator.userAgent.indexOf("Safari") > -1;
}

const isChrome = () => {
  return navigator.userAgent.indexOf("Chrome") > -1;
}

const usePrevState = (value) => {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}

export { isSafari, isChrome, usePrevState };
